import React from 'react';
import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			margin: '0 auto',
			paddingRight: '0.75rem',
			paddingLeft: '0.75rem',
			position: 'relative',
			[theme.breakpoints.up('sm')]: {
				maxWidth: 540,
			},
			[theme.breakpoints.up('md')]: {
				maxWidth: 720,
			},
			[theme.breakpoints.up('lg')]: {
				maxWidth: 960,
			},
			[theme.breakpoints.up('xl')]: {
				maxWidth: 1140,
			},
		},
	})
);

const PageContainer = ({ children }: { children: React.ReactNode }) => {
	const classes = useStyles();
	return <div className={classes.root}>{children}</div>;
};

export default PageContainer;
